<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Channel Viewing Slots</h1>
          <div class="has-text-right">
            <b-button
              type="is-primary"
              icon-left="plus"
              tag="router-link"
              :to="{
                name: 'CreateChannelViewingSlot',
                params: { id: $route.params.id },
              }"
              >Add</b-button
            >
          </div>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="filteredChannelViewingSlots"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Name">
                <router-link
                  :to="{
                    name: 'EditChannelViewingSlot',
                    params: { id: props.row.id },
                  }"
                  >{{ props.row.name }}</router-link
                >
              </b-table-column>

              <b-table-column class="has-text-centered">
                <b-dropdown aria-role="list">
                  <button slot="trigger" class="button is-primary">
                    <span>Actions</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'EditChannelViewingSlot',
                        params: { id: props.row.id },
                      }"
                      >Edit</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="confirmDelete(props.row)"
                    >Delete</b-dropdown-item
                  >
                </b-dropdown>
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No channels yet.</p>
                </div>
              </section>
            </template>
          </b-table>
          <div class="has-text-centered has-margin-top-15">
            <div class="is-block has-margin-bottom-15">
              <b-button
                icon-left="arrow-left"
                class="is-medium has-margin-right-10"
                tag="router-link"
                :to="{
                  name: 'ManageChannels',
                }"
              >
                Back to Channels</b-button
              >
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import ChannelViewingSlotApi from '@/api/channelViewingSlots'
export default {
  name: 'ManageChannelViewingSlots',
  components: {
    CardComponent,
  },
  metaInfo: {
    title: 'Manage Channel Viewing Slots',
  },
  computed: {
    ...mapGetters(['user']),
    filteredChannelViewingSlots() {
      if (this.search !== '' && this.items.length > 0) {
        let query = this.search.toLowerCase()
        return this.items.filter((item) =>
          item.name.toLowerCase().includes(query)
        )
      } else {
        return this.items
      }
    },
  },
  created() {
    this.fetchChannelViewingSlots()
  },
  data() {
    return {
      loading: true,
      items: [],
      search: '',
      item: {},
    }
  },
  methods: {
    ...mapActions(['getUser']),
    confirmDelete(item) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this item?',
        onConfirm: async () => {
          this.loading = true
          await ChannelViewingSlotApi.remove(item)
          this.fetchChannelViewingSlots()
          this.$buefy.toast.open({
            message: 'Channel Viewing Slot deleted successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.loading = false
        },
      })
    },
    async fetchChannelViewingSlots() {
      this.loading = true
      this.items = await ChannelViewingSlotApi.getByChannel(
        this.$route.params.id
      )
      this.loading = false
    },
  },
}
</script>
